import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { map } from "rxjs/operators";
import { AccesoService } from '../acceso/acceso.service';
import { environment } from '../../../environments/environment';
@Injectable({
  providedIn: "root"
})
export class LoginService {

 dataUser:any; 
 clickGuard:any;
 IdrolUser:any;
 uploadImage:any;
 TipoCambio:any;

 comboAdquirente:any;
 comboProveedor:any;
 dataPermiso:any;
 reloadPermiso:any;
 header : HttpHeaders;
 
  credenciales = {
    grant_type: "client_credentials",
    client_id: 2,
    client_secret: "863EOgvVNFYgvVzwEWyvsi6qqX11GNtJN3Mf7kwt"
  };
  readonly urlBase =  environment.rutaBase;
    
  TOKEN: string;

  constructor( private http: HttpClient  , private accesoService :AccesoService) { 
    this.header = this.accesoService.desencriptarTOKEN();
  }
  obtenerToken() {
    return this.http.post(`${this.urlBase}/security/token`,this.credenciales);
  }

  createUsuario(usuario: any) {
    let headers = this.header;
    return this.http.post(`${this.urlBase}/security/usersPR`, usuario, { headers } );
  }

  editarUsuario(usuario: any) {
    let headers = this.header;
    return this.http.put(`${this.urlBase}/security/updatePR`, usuario, { headers } );
  }

  validarUsuario(usuario: any) {
    let headers = this.header;
    return this.http.post(`${this.urlBase}/security/loginPR`, usuario, { headers } );
    
  }

  listarUsuarios(id_empresa: any) {
    let headers = this.header;
    return this.http.get(`${this.urlBase}/security/usersPR?id_empresa=${id_empresa}`, { headers } );
  }

  recuperarCuenta(usuario: any) {
    let headers = this.header;
    return this.http.post(`${this.urlBase}/security/recoverPR`, usuario, { headers } );
  }
  
  cambiarContraseña(usuario: any){
    let headers = this.header;
    return this.http.post(`${this.urlBase}/security/changePasswordPR`, usuario, { headers } );
  }
  
  ListarComponenteServ(id_componente_padre: any){
   let headers :  HttpHeaders = new HttpHeaders();
    headers =  headers.append('Accept', 'application/json');
    headers =  headers.append('Authorization', `hIlU8KlOT1`);
   return this.http.get(`https://2-dot-seguridad-dot-desarrollo-innova.appspot.com/api-seguridad/ListarComponentePadre?id_componente_padre=${id_componente_padre}`, { headers } );
  }
  
  editarUsuarioServ(body : string,id_user : string){

    let headers = this.header;

   return  this.http.put(`${this.urlBase}/security/UpdateUser/${id_user}`,body,{headers})
        .pipe( 
          map ( (data) => {
                return data;
              }))

  }

  generarCodigoActivacion(data:any){
    let headers = this.header;
    return this.http.post(`${this.urlBase}/security/ActivationCodePR`, data, { headers } );
  }

  getIP() {
    let headers :  HttpHeaders = new HttpHeaders();
    headers =  headers.append('access-control-allow-origin', '*,*'); 
    return this.http.get<any>('https://ipv4.jsonip.com/',  { headers });
  }
}
